import { createSlice, PayloadAction } from '@reduxjs/toolkit' ;
import { RootState } from '../../app/store'
import { sanitizeEmail } from '../../utils/emailUtils';

export interface CurrentAttendeeState {
    attendeeEmail: string
    status: 'idle' | 'loading' | 'failed'
}

const initialState: CurrentAttendeeState ={
    attendeeEmail: '',
    status: 'idle'
}
export const currentAttendeeSlice = createSlice({
    name:'currentAttendee' , 
    initialState: initialState,
    reducers: {
        setAttendeeEmail: (state, action: PayloadAction<string>) => {
            state.attendeeEmail =  sanitizeEmail(action.payload)
        }
    }
})

export const selectAttendeeEmail = (state: RootState) => state.currentAttendee.attendeeEmail;
export const { setAttendeeEmail} = currentAttendeeSlice.actions

export default currentAttendeeSlice.reducer
